module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "title": _vm.title,
      "top": "5%",
      "size": "large",
      "before-close": _vm.close
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('div', {
    staticClass: "group-buy-form-wrapper"
  }, [_c('el-form', {
    attrs: {
      "label-width": "120px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "团购大图",
      "required": ""
    }
  }, [_c('el-upload', {
    ref: "upload",
    attrs: {
      "list-type": "picture-card",
      "accept": "image/*",
      "multiple": false,
      "action": "",
      "http-request": _vm.handleUpload.bind(this, 'groupon'),
      "file-list": _vm.img,
      "on-remove": _vm.handleRemove.bind(this, 'groupon')
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  })])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "团购名称",
      "required": ""
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.name),
      callback: function($$v) {
        _vm.$set(_vm.form, "name", $$v)
      },
      expression: "form.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "团购描述",
      "required": ""
    }
  }, [_c('div', {
    staticClass: "product-list-wrapper"
  }, [_c('form', {
    staticClass: "product-form mt10"
  }, [_vm._l((_vm.form.description), function(item, index) {
    return [(item.type == 1) ? [_c('div', {
      staticClass: "mb20"
    }, [_c('el-input', {
      staticClass: "description-text el-form-item",
      attrs: {
        "type": "textarea",
        "rows": 4
      },
      model: {
        value: (item.text),
        callback: function($$v) {
          _vm.$set(item, "text", $$v)
        },
        expression: "item.text"
      }
    }), _vm._v(" "), (index > 0) ? _c('i', {
      staticClass: "el-icon-delete del-description",
      on: {
        "click": function($event) {
          return _vm.removeDescriptionText(item, index)
        }
      }
    }) : _vm._e()], 1)] : _vm._e(), _vm._v(" "), (item.type == 2) ? _c('div', {
      on: {
        "click": function($event) {
          return _vm.removeImage(item, index)
        }
      }
    }, [_c('ul', {
      staticClass: "el-upload-list el-upload-list--picture-card"
    }, [_c('li', {
      staticClass: "el-upload-list__item is-success"
    }, [_c('img', {
      staticClass: "el-upload-list__item-thumbnail",
      attrs: {
        "src": _vm._f("ossurl")(item.text),
        "alt": ""
      }
    }), _vm._v(" "), _c('label', {
      staticClass: "el-upload-list__item-status-label"
    }, [_c('i', {
      staticClass: "el-icon-upload-success el-icon-check"
    })]), _vm._v(" "), _c('span', {
      staticClass: "el-upload-list__item-actions"
    }, [_c('span', {
      staticClass: "el-upload-list__item-delete"
    }, [_c('i', {
      staticClass: "el-icon-delete2"
    })])])])])]) : _vm._e()]
  }), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "size": "tiny"
    },
    model: {
      value: (_vm.dialogVisible),
      callback: function($$v) {
        _vm.dialogVisible = $$v
      },
      expression: "dialogVisible"
    }
  }, [_c('img', {
    attrs: {
      "width": "100%",
      "src": _vm.dialogImageUrl,
      "alt": ""
    }
  })]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.handleAddText()
      }
    }
  }, [_vm._v("添加文字")]), _vm._v(" "), _c('el-upload', {
    staticClass: "el-button el-button--primary",
    attrs: {
      "accept": "image/*",
      "multiple": false,
      "show-file-list": false,
      "action": "",
      "http-request": _vm.addImagesUpload,
      "on-preview": _vm.addImagesPreview
    }
  }, [_c('i', [_vm._v("添加图片")])])], 2)])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "配送方式"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.form.delivery),
      callback: function($$v) {
        _vm.$set(_vm.form, "delivery", $$v)
      },
      expression: "form.delivery"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("自提")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 2
    }
  }, [_vm._v("送货上门")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "自提地址"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.pickupAddress),
      callback: function($$v) {
        _vm.$set(_vm.form, "pickupAddress", $$v)
      },
      expression: "form.pickupAddress"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "团购状态",
      "required": ""
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.form.status),
      callback: function($$v) {
        _vm.$set(_vm.form, "status", $$v)
      },
      expression: "form.status"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("未开始")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 0
    }
  }, [_vm._v("进行中")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 2
    }
  }, [_vm._v("已结束")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "开始结束时间"
    }
  }, [_c('el-date-picker', {
    staticClass: "date-range-picker",
    attrs: {
      "type": "daterange",
      "placeholder": "选择日期范围"
    },
    model: {
      value: (_vm.form.range),
      callback: function($$v) {
        _vm.$set(_vm.form, "range", $$v)
      },
      expression: "form.range"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "团购商品",
      "required": ""
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "icon": "plus"
    },
    on: {
      "click": _vm.formAddProduct
    }
  }, [_vm._v("添加商品")])], 1), _vm._v(" "), _c('div', {
    staticClass: "product-list-wrapper"
  }, _vm._l((_vm.form.groupon_items), function(item, index) {
    return _c('form', {
      staticClass: "product-form mt10"
    }, [(index > 0) ? _c('i', {
      staticClass: "el-icon-close del-groupon",
      on: {
        "click": function($event) {
          return _vm.removeProductForm(item, index)
        }
      }
    }) : _vm._e(), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "商品名称",
        "required": ""
      }
    }, [_c('el-input', {
      model: {
        value: (item.name),
        callback: function($$v) {
          _vm.$set(item, "name", $$v)
        },
        expression: "item.name"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "商品价格",
        "required": ""
      }
    }, [_c('el-input', {
      model: {
        value: (item.price),
        callback: function($$v) {
          _vm.$set(item, "price", $$v)
        },
        expression: "item.price"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "商品描述"
      }
    }, [_c('el-input', {
      attrs: {
        "type": "textarea",
        "rows": 2
      },
      model: {
        value: (item.description),
        callback: function($$v) {
          _vm.$set(item, "description", $$v)
        },
        expression: "item.description"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "限制购买数量"
      }
    }, [_c('el-input', {
      model: {
        value: (item.limit),
        callback: function($$v) {
          _vm.$set(item, "limit", (typeof $$v === 'string' ? $$v.trim() : $$v))
        },
        expression: "item.limit"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "商品图片"
      }
    }, [_c('el-upload', {
      attrs: {
        "list-type": "picture-card",
        "accept": "image/*",
        "multiple": false,
        "action": "",
        "http-request": _vm.handleUpload.bind(this, 'product_' + index),
        "file-list": item.fileList,
        "on-remove": _vm.handleRemove.bind(this, 'product_' + index)
      }
    }, [_c('i', {
      staticClass: "el-icon-plus"
    })])], 1)], 1)
  }), 0)], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.visible = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.saving
    },
    on: {
      "click": _vm.handleAddGroupBuy
    }
  }, [_vm._v("确 定")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2d80ba25","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/add-groupon-dialog.vue
// module id = 808
// module chunks = 1